import { atom, useSetAtom } from 'jotai';

import { getCurrentYear } from '@/utils/common';

const currentYear = getCurrentYear();

const initialProductsFormState: ProductDetailResponse = {
  productsImage: {
    id: 0,
    certificateImageUrl: '',
    frontSideImageUrl: '',
    backSideImageUrl: '',
    frontImageUrl: '',
    backImageUrl: '',
    tireImageUrl: '',
    engineImageUrl: '',
    insideImageUrl: '',
    dashboardImageUrl: '',
    sheetImageUrl: '',
    optionImageUrl: [] as string[] | null,
    engineVideoUrl: '',
  },
  manufacturerCategories: {
    id: 0,
    name: '',
    code: '',
  },
  model: {
    id: 0,
    name: '',
  },
  accidentsHistory: {
    id: 0,
    accidentContents: null,
    createdBy: null,
    createdDate: '',
    modifiedBy: null,
    modifiedDate: '',
    accident: false,
  },
  maintenance: {
    id: 0,
    maintenanceData: [],
    etc: '',
    createdBy: null,
    createdDate: '',
    modifiedBy: null,
    modifiedDate: '',
  },
  carOption: {
    id: 0,
    normalOption: {
      option: [],
      etc: '',
    },
    additionalOption: {
      option: [],
      etc: '',
    },
    breakOption: {
      option: [],
      etc: '',
    },
    createdBy: null,
    createdDate: '',
    modifiedBy: null,
    modifiedDate: '',
  },
  sellerId: 0,
  sellerSafetyNumber: '',
  id: 0,
  productsNumber: 0,
  ownerName: '',
  status: {
    code: '',
    desc: '',
  },
  productStatus: {
    code: '',
    desc: '',
  },
  type: {
    code: '',
    desc: '',
  },
  salesType: null,
  price: null,
  actualSalePrice: null,
  truckNumber: '',
  truckName: '',
  tons: '',
  year: '',
  firstRegistrationDate: '',
  power: '',
  transmission: {
    code: '',
    desc: '',
  },
  axis: {
    code: '',
    desc: '',
  },
  distance: 0,
  loaded: {
    code: '',
    desc: '',
  },
  loadedInnerLength: '',
  loadedInnerArea: '',
  loadedInnerHeight: '',
  color: {
    code: '',
    desc: '',
  },
  fuel: {
    code: '',
    desc: '',
  },
  transportGoods: '',
  transportStartLocate: null,
  transportEndLocate: null,
  tireStatus: null,
  carUse: '',
  carType: '',
  motorType: '',
  identificationNumber: '',
  originDetail: '',
  detailContent: '',
  hit: 0,
  inspectionInvalidStartDate: '',
  inspectionInvalidEndDate: '',
  modifiedPriceDate: '',
  garage: {
    code: '',
    desc: '',
  },
  area1: '',
  area2: '',
  area3: '',
  carRegisterSearchDate: '',
  tradingHistory: [],
  inspectionHistory: [],
  tuningHistory: [],
  lastOwnerInfo: {
    date: '',
    content: '',
  },
  createdDate: '',
  modifiedDate: '',
  modifiedBy: '',
  isDelete: false,
  license: null,
  youtubeUrl: '',
};

const initialSearchParams: ProductsSearch = {
  keyword: '',
  manufacturerCategoriesId: new Set([]),
  minYear: '2000',
  maxYear: (currentYear + 1).toString(),
  minTons: '1',
  maxTons: '27',
  minDistance: '0',
  maxDistance: '200',
  axis: '',
  transmission: '',
  loaded: new Set([]),
  minLoadedInnerLength: '',
  maxLoadedInnerLength: '',
  salesType: 'ALL',
  productsSortType: { code: 'CREATED_DATE', desc: '기본 정렬순' },
  page: 1,
  area1: '',
  area2: '',
  area3: '',
};

export const productsFormAtom = atom<ProductDetailResponse>(initialProductsFormState);
export const productsSearchParamsAtom = atom<ProductsSearch>(initialSearchParams);

// 판매 등록 과정 중 번호판 정보 임시 저장 (등록 완료 API 호출 전까지 유지)
export interface LicenseDraft {
  license: {
    id?: number;
    productId: number;
    licenseType: EnumPresenter;
    price: number;
    maxTons: number;
    tons: number;
  } | null;
  isLicenseIncludeSale: boolean | null;
}

export const initialLicenseDraft: LicenseDraft = {
  license: null,
  isLicenseIncludeSale: null,
};

export const licenseDraftAtom = atom<LicenseDraft>(initialLicenseDraft);

export const useResetLicenseDraft = () => {
  const setLicenseDraft = useSetAtom(licenseDraftAtom);
  return () => setLicenseDraft(initialLicenseDraft);
};

export const useResetProductsForm = () => {
  const setProductsForm = useSetAtom(productsFormAtom);
  const setLicenseDraft = useSetAtom(licenseDraftAtom);
  return () => {
    setProductsForm(initialProductsFormState);
    setLicenseDraft(initialLicenseDraft);
  };
};
